export default __webpack_public_path__ + "static/media/2022_Juli_Zettel.5f216535.webp";